const scrollTo = ({ elementID, position }) => {
    if (!!elementID) {
        const scrollPosition = position === 'start' ? true : false
        const element = document.getElementById(elementID)
        setTimeout(() => {
            element?.scrollIntoView(scrollPosition)
        }, 500)
    }
}

export default scrollTo
